import { Article } from "./article";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { fetchArticle } from "../../../store/thunks/article";

const mapStateToProps = state => {
  return {
    uid: state.articleState.uid,
    title: state.articleState.title,
    content: state.articleState.content,
    author: state.articleState.author,
    meta_description: state.articleState.meta_description,
    social_share_image: state.articleState.social_share_image,
    date_published: state.articleState.date_published,
    date_modified: state.articleState.date_modified
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchArticle: bindActionCreators(fetchArticle, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Article);
